import { client } from "api";

export type LoginRequest = {
  email: string;
  password: string;
};

export type LoginResponse = {
  state: string;
  userId: string;
  token: string;
};

export type LoginError = {
  message: string;
};

export const login = (data: LoginRequest) =>
  client.post<LoginResponse>(`/auth`, data).then((res) => res.data);
